import { flatFunnelFillPlugin } from '@utils/chartPlugins'

export const buildBarChartPluginsProp = () => {
  return [flatFunnelFillPlugin]
}
